import React, { useState, cloneElement } from 'react';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Icon from '@/componentsDS/Icon/Icon';
import { IconSize, IconStyle } from '@/componentsDS/Icon/Icon.type';
import { deepFind, deepFilter } from 'react-children-utilities';
import Button from '@/componentsDS/Button/Button';
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';
import PropTypes from "prop-types";

const AccordionCardConfigure = ({ children, ...rest }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const header = deepFind(children, child => child.type === CardConfigure.Header);
  const title = deepFind(children, child => child.type === CardConfigure.Header.Title);
  const otherChildren = deepFilter(children, child =>
    ![CardConfigure.Header].includes(child.type)
  );

  const renderHeader = header && title
    ? cloneElement(header, {
        children: React.Children.map(header.props.children, child => {
          if (child.type === CardConfigure.Header.Title) {
            return cloneElement(child, {
              children: (
                <div className='accordian_card-configure__header'>
                  <Button text={<Icon name = {isOpen ? 'chevron-up' : 'chevron-down'} size = {IconSize.SMALL} style={IconStyle.OUTLINED}/>} type = {ButtonType.UTILITY} variant = {ButtonVariant.UTILITY} onClick={toggleAccordion}/>
                  {child.props.children}
                </div>
              )
            });
          }
          return child;
        })
      })
    : header;


  return (
    <CardConfigure {...rest}>
      {renderHeader}
      {isOpen && otherChildren}
    </CardConfigure>
  );
};

export default AccordionCardConfigure;


AccordionCardConfigure.propTypes = {
	children: PropTypes.node
};